<template>
  <div id="sysdetail">
    <el-dialog
      center
      top="10vh"
      :title="dialogdata.title"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      @close="cancel"
      width="1100px"
    >
      <div class="dialogNotice" v-loading="loadings" :element-loading-text="loadingText">
        <div style="margin-bottom: 20px;font-weight: bold;">{{dialogdata.summary}}</div>
        <div class="urlcontainer">
          <div v-html="decodeURIComponent(dialogdata.content)"></div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import bus from '@/assets/utils/bus'
  import {getLocalTime} from '@/assets/utils/index'
  export default {
    data(){
      return {
        getLocalTime:getLocalTime,
        dialogVisible:false,
        loadings:false,
        loadingText:'查询中',
        dialogdata:''
      }
    },
    computed: {

    },
    created(){
      bus.$on('returndetail',val=>{
        this.dialogVisible=true
        this.dialogdata=val
      })
    },
    methods:{
      cancel(){
        this.dialogVisible=false
        bus.$emit('showdilog')
      },

    },
    mounted() {

    },
    watch:{
      // sysData: {
      //   handler(newName, oldName) {
      //     console.log(newName)
      //     this.dialogVisible = newName.show;
      //     this.dialogdata=newName.msgdata
      //   },
      //   deep:true,
      //   immediate: true
      // }
    }
  }
</script>
<style lang="less">
  #sysdetail{
    .el-dialog__header{
      border-bottom: none !important;
    }
    .el-dialog__footer{
      border-top: none !important;
    }
  }
</style>
<style scoped>
  .dialogNotice .locktips{
    width: 100%;
    color: red;
    text-align: center;
    padding: 10px;
    padding-top: 0;
  }
  .dialogNotice .urlcontainer{
    box-sizing: border-box;
    padding: 20px;
    margin-top: 10px;
    height: 620px;
    overflow-y: auto;
    width: 100%;
    border: 1px solid #e0e0e0;
  }
  .urlcontainer >>> img{
    max-width: 100%;
    display: block;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .urlcontainer >>> video{
    max-width: 100%;
    display: block;
    margin-top: 10px;
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/dialog/sysdetail.vue